import { useMemo } from 'react';
import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useProfileChartsDataContext } from './hooks/useProfileChartsDataContext';

const monthNames = [
    'Jan',
    'Fev',
    'Mar',
    'Abr',
    'Maio',
    'Jun',
    'Jul',
    'Ago',
    'Set',
    'Out',
    'Nov',
    'Dez'
];

const getMonthLabel = (mes) => {
    const monthIndex = parseInt(mes) - 1;
    const monthName = monthNames[monthIndex] || mes;
    return `${monthName}`;
};

export const ByPeopleTypeMonth = () => {
    const { chartData } = useProfileChartsDataContext();

    const { series, categories } = useMemo(() => {
        let monthData = chartData?.byPeopleTypeMonth || [];
        
        if (!monthData.length) {
            return { series: [], categories: [] };
        }

        // Sort data chronologically by year and month
        monthData = [...monthData].sort((a, b) => {
            const yearDiff = parseInt(a.ano_estatistica) - parseInt(b.ano_estatistica);
            if (yearDiff !== 0) return yearDiff;
            return parseInt(a.mes_estatistica) - parseInt(b.mes_estatistica);
        });

        // Limit to 12 consecutive months (last 12)
        monthData = monthData.slice(-12);

        // Get all unique people types
        const peopleTypeSet = new Set();
        monthData.forEach(period => {
            period.tipos_pessoa?.forEach(peopleType => {
                peopleTypeSet.add(peopleType.tipo_pessoa);
            });
        });

        // Create series for each people type
        const peopleTypeSeries = Array.from(peopleTypeSet).map(peopleTypeName => {
            const data = monthData.map(period => {
                const peopleTypeData = period.tipos_pessoa?.find(b => b.tipo_pessoa === peopleTypeName);
                return peopleTypeData?.total || 0;
            });
            return {
                name: peopleTypeName,
                data: data
            };
        });

        // Get month/year as categories
        const monthCategories = monthData.map(item => 
            getMonthLabel(item.mes_estatistica)
        );

        return {
            series: peopleTypeSeries,
            categories: monthCategories
        };
    }, [chartData?.byPeopleTypeMonth]);


    return (
        <SimpleBars
            title="Por Tipo de Pessoa (Mensal)"
            horizontal={true}
            subtitles={categories}
            series={series}
            height={420}
            showDataLabels={true}
            stacked
        />
    );
};
